import { DEFAULT_COSMETIC_LOADOUT, cosmeticItem, type CosmeticItem } from "@craftoff/game-core";
import { type CSSProperties } from "react";

export function cosmeticThemeClass(itemId: string): string {
  return itemId.replace(/[^a-z0-9-]/g, "");
}

type CosmeticStyle = CSSProperties & {
  "--table-surface"?: string;
  "--table-edge"?: string;
  "--table-highlight"?: string;
  "--table-accent"?: string;
  "--table-label"?: string;
  "--craft-slot-texture"?: string;
};

export function cosmeticTableStyle(craftingTableId: string): CosmeticStyle | undefined {
  const item = cosmeticItem(craftingTableId);
  const palette = item?.tablePalette;
  if (!palette) return undefined;
  return {
    "--table-surface": palette.surface,
    "--table-edge": palette.edge,
    "--table-highlight": palette.highlight,
    "--table-accent": palette.accent,
    "--table-label": palette.label,
    "--craft-slot-texture": item.slotTexturePath ? `url(${item.slotTexturePath})` : undefined
  };
}

export function AvatarFaceplate({ faceplateId, label }: { faceplateId: string; label?: string }) {
  const item = cosmeticItem(faceplateId) ?? cosmeticItem(DEFAULT_COSMETIC_LOADOUT.faceplateId);
  return (
    <span className={`avatar-faceplate faceplate-${cosmeticThemeClass(faceplateId)}`} aria-label={label} role={label ? "img" : undefined}>
      {item?.assetPath ? <img className="avatar-face-image" src={item.assetPath} alt="" /> : <i className="avatar-face"><b /><b /><em /></i>}
      <i className="faceplate-corner top-left" /><i className="faceplate-corner top-right" />
      <i className="faceplate-corner bottom-left" /><i className="faceplate-corner bottom-right" />
    </span>
  );
}

export function CraftingTablePreview({ craftingTableId }: { craftingTableId: string }) {
  const style = cosmeticTableStyle(craftingTableId);
  return (
    <span className={`cosmetic-table-preview table-theme-${cosmeticThemeClass(craftingTableId)}`} style={style} aria-hidden="true">
      <i className="mini-table-grid">{Array.from({ length: 9 }, (_, index) => <b key={index} />)}</i>
    </span>
  );
}

export function WallpaperPreview({ wallpaperId }: { wallpaperId: string }) {
  const item = cosmeticItem(wallpaperId);
  return (
    <span className={`cosmetic-wallpaper-preview wallpaper-${cosmeticThemeClass(wallpaperId)} ${item?.assetPath ? "custom-wallpaper-preview" : ""}`} aria-hidden="true">
      {item?.assetPath ? <img src={item.assetPath} alt="" /> : <><i className="preview-sun" /><i className="preview-ridge back" /><i className="preview-ridge front" /></>}
    </span>
  );
}

export function CosmeticPreview({ item }: { item: CosmeticItem }) {
  if (item.category === "wallpaper") return <WallpaperPreview wallpaperId={item.id} />;
  if (item.category === "crafting-table") return <CraftingTablePreview craftingTableId={item.id} />;
  return <span className="cosmetic-faceplate-preview"><AvatarFaceplate faceplateId={item.id} /></span>;
}
